import {
  PlanBoxFeatureRow,
  PlanBoxFeatureRowText,
  PlanBoxFeaturesWrapper,
} from 'Features/pricing/components/PlanBox/PlanBox.styled'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/pro-light-svg-icons'
import React from 'react'
import { PlanTypes } from 'Types/PlansTypes'
import { PlansJson } from 'Types/Plan'
import { useTranslation } from 'react-i18next'
import { IconProp } from '@fortawesome/fontawesome-svg-core'

type PlanBoxFeaturesProps = {
  planName: PlanTypes
  plansJson: PlansJson
  crossSell?: boolean
}

export const PlanBoxFeatures = ({ plansJson, planName, crossSell }: PlanBoxFeaturesProps) => {
  const { t } = useTranslation('pricing')

  const renderFeatures = () => {
    return plansJson[planName].features.map((feature, index) => {
      return (
        <PlanBoxFeatureRow key={index}>
          <FontAwesomeIcon
            icon={faCheck as IconProp}
            color={'var(--colors-primaryColor)'}
            style={{ marginTop: '3px' }}
          />
          <PlanBoxFeatureRowText crossSell={crossSell}>{t(`${feature}`)}</PlanBoxFeatureRowText>
        </PlanBoxFeatureRow>
      )
    })
  }

  return <PlanBoxFeaturesWrapper>{renderFeatures()}</PlanBoxFeaturesWrapper>
}
